import React from 'react';
import { NavLink } from 'src';


export default function DemoBreadcrumb() {
  return <NavLink to="/">home</NavLink>;
}



// WEBPACK FOOTER //
// ./demo/src/components/routes/ItemView/components/DemoNavLink.js